"use strict";

const WqRoutes = function () {
  const MuniOutfallFactSheetController = require("../../muni/muniOutfallFactSheetController");
  const SamplingSiteFactSheetController = require("../../wq/samplingSiteFactSheetController");
  const CompositeAssetId = require("../../general/compositeAssetId");

  const outfallsFactSheetRoute = {
    as: "outfalls-fact-sheet",
    handler: function ({ data, hashString }) {
      MuniOutfallFactSheetController.open(data.id, { highlightId: hashString });
    },
    data: { dataView: "outfalls" },
  };

  const wqMonitoringFactSheetRoute = {
    as: "wq-monitoring-fact-sheet",
    handler: function ({ data, hashString }) {
      const options = { highlightId: hashString, compositeId: data.id };
      const { assetType, id } = CompositeAssetId.parse(data.id);
      if (assetType === "outfall") {
        MuniOutfallFactSheetController.open(id, options);
      } else if (assetType === "samplingSite") {
        SamplingSiteFactSheetController.open(id, options);
      } else {
        throw new Error(`Unknown asset type for WQ Monitoring fact sheet: ${assetType}`);
      }
    },
    data: { dataView: "wq-monitoring" },
  };

  return {
    outfallsFactSheetRoute,
    wqMonitoringFactSheetRoute,
  };
};

module.exports = WqRoutes();
